import React from "react";
import { MainSection } from "@/styles/global";
import { IWPImage, IWPLink } from "@/src/types";
import S from "./Cards.styled";
import { getBgColor, toGatsbyImage } from "@/src/helpers";
import Button from "@/components/global-components/Button";

export interface CardsProps {
  title: string;
  text: string;
  backgroundColor: string;
  cardsList: {
    cardBackgroundColor: string;
    cardImage: IWPImage;
    cardTitle: string;
    cardText: string;
    cardButton: IWPLink;
  }[];
}

const Cards: React.FC<CardsProps> = ({
  text,
  title,
  backgroundColor,
  cardsList,
}) => {
  const [bgColor, setBgColor] = React.useState<string>("");

  React.useEffect(() => {
    if (cardsList.some((card) => card.cardBackgroundColor !== "standard")) {
      setBgColor("#FCFCFC");
    } else {
      setBgColor(backgroundColor);
    }
  }, [cardsList, backgroundColor]);

  const renderCards = cardsList?.map(
    (
      { cardButton, cardImage, cardText, cardTitle, cardBackgroundColor },
      index
    ) => {
      const imageData = toGatsbyImage(cardImage);
      const bgColorCard = (color: string) => {
        if (color === "standard" && backgroundColor === "#FCFCFC") {
          return "#EAEAEF";
        } else if (
          (color === "standard" && backgroundColor === "#EAEAEF") ||
          backgroundColor === "#F5F5F5"
        ) {
          return "#FCFCFC";
        } else {
          return getBgColor("light", cardBackgroundColor);
        }
      };

      return (
        <S.Card key={index} $bgColor={bgColorCard(cardBackgroundColor)}>
          {imageData && (
            <S.CardImage image={imageData} alt={cardImage.altText || ""} />
          )}
          <S.TextWrapper>
            {cardTitle && <S.CardTitle>{cardTitle}</S.CardTitle>}
            {cardText && <S.Text>{cardText}</S.Text>}
            {cardButton && (
              <S.ButtonWrapper>
                <Button link={cardButton} type="primary" />
              </S.ButtonWrapper>
            )}
          </S.TextWrapper>
        </S.Card>
      );
    }
  );

  return (
    <MainSection $bgColor={bgColor}>
      <S.Inner>
        <S.TitleWrapper>
          {title && <S.Title>{title}</S.Title>}
          {text && <S.Text>{text}</S.Text>}
        </S.TitleWrapper>
        <S.CardsWrapper $arrayLength={cardsList.length}>
          {renderCards}
        </S.CardsWrapper>
      </S.Inner>
    </MainSection>
  );
};

export default Cards;
